<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{"attach" | translate}}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" (click)="fnCloseAttachReceiptOptionsPanel()" class="btn eod-btn-outline-warning height-38px">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="clear"></div>
        <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
                <div class="block">
                    <ul class="bulkList margin-bottom-0">
                        <li (click)="fnShowFilePicker()" class="f-14 padding-bottom-0">
                            <span class="d-inline-block" *ngIf="userType==0">
                                <i class="fas fa-image padding-right-10 w-30" aria-hidden="true">
                                </i>
                                {{ "upload_receipt_and_pdf" | translate:param }}
                            </span>
                            <span class="d-inline-block" *ngIf="userType==1">
                                <i class="fas fa-image padding-right-10 w-30" aria-hidden="true">
                                </i>
                                {{ "upload_document_and_pdf" | translate:param }}
                            </span>
                        </li>
                        @if(claimType != claimTypeEnum.Invoice && claimType != claimTypeEnum.Vendor)
                        {
                        <li *ngIf="userType==0 && !hideCCOption" (click)="fnShowExpenseMergePanel(1)" class="f-14">
                            <span class="d-inline-block">
                                <i class="fas fa-file-alt padding-right-10 w-30" aria-hidden="true"></i>
                                {{ "incomplete_cc_rec_label" | translate:param }}
                            </span>
                        </li>
                        <li *ngIf="userType==0 && !hideSavedEmailReciepts" (click)="fnShowExpenseMergePanel(2)" class="f-14 m-0">
                            <span class="d-inline-block">
                                <i class="fas fa-file-alt padding-right-10 w-30" aria-hidden="true"></i>
                                {{ "expense_merge_panel_emailed_reciepts" | translate:param }}
                            </span>
                        </li>
                        }
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>